'use client';

import { addClassName } from '@hc-frontend/core-utils-format';
import { useState } from 'react';

import type { TooltipProps } from './tooltip.types';

export function Tooltip({
  title,
  children,
  className,
  triggerClassName,
}: TooltipProps) {
  const [showTooltip, setShowTooltip] = useState(false);

  return (
    <div
      className={addClassName('relative', triggerClassName)}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {children}
      {showTooltip && (
        <div
          className={addClassName(
            'absolute z-10 rounded bg-gray-950 px-4-8 py-2-4 text-sm text-text-0 shadow-md',
            className,
          )}
        >
          {title}
        </div>
      )}
    </div>
  );
}
